import Default from '../../layouts/default';


const indexRoutes = [
  { path: '/', component: Default },
  { path: '', component: Default },

];

export default indexRoutes;
